// removed by extract-text-webpack-plugin
module.exports = {"container":"_956599c497_src-bootstrap-Errors-_ErrorCandy_container","enter":"_5e3f76b204_src-bootstrap-Errors-_ErrorCandy_enter","message":"_403d450a68_src-bootstrap-Errors-_ErrorCandy_message","dismiss":"_14e2fc70d1_src-bootstrap-Errors-_ErrorCandy_dismiss"};


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/Errors/ErrorCandy.css
// module id = 1685
// module chunks = 0